import { render, staticRenderFns } from "./addClaim.vue?vue&type=template&id=19dce894&scoped=true"
import script from "./addClaim.vue?vue&type=script&lang=js"
export * from "./addClaim.vue?vue&type=script&lang=js"
import style0 from "./addClaim.vue?vue&type=style&index=0&id=19dce894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dce894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19dce894')) {
      api.createRecord('19dce894', component.options)
    } else {
      api.reload('19dce894', component.options)
    }
    module.hot.accept("./addClaim.vue?vue&type=template&id=19dce894&scoped=true", function () {
      api.rerender('19dce894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerReportManage/addClaim.vue"
export default component.exports